import React, { useState } from 'react';
import { Save, Settings2 } from 'lucide-react';
import { pumpConfigurations } from '../mockData';

const FUEL_TYPES = ['Petrol', 'Diesel', 'Xtragreen'];

const PumpConfig = () => {
  const [pumps, setPumps] = useState(pumpConfigurations);

  const handleTypeChange = (pumpId, nozzleId, newType) => {
    setPumps(pumps.map(pump => {
      if (pump.pumpId === pumpId) {
        return {
          ...pump,
          nozzles: pump.nozzles.map(n => n.id === nozzleId ? { ...n, type: newType } : n)
        };
      }
      return pump;
    }));
  };

  return (
    <div className="space-y-6 max-w-4xl mx-auto">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Pump & Nozzle Configuration</h1>
          <p className="text-slate-500 text-sm mt-1">Assign fuel types to nozzles for accurate accounting</p>
        </div>
        <button className="btn-primary flex items-center gap-2">
          <Save className="w-4 h-4" /> Save Configuration
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {pumps.map(pump => (
          <div key={pump.pumpId} className="glass-panel p-6 border-t-4 border-t-slate-800">
            <h2 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
              <Settings2 className="w-5 h-5 text-slate-400" /> Pump {pump.pumpId}
            </h2>
            
            <div className="space-y-4">
              {pump.nozzles.map(nozzle => (
                <div key={nozzle.id} className="bg-slate-50 p-4 rounded-xl border border-slate-200">
                  <div className="flex items-center justify-between">
                    <span className="font-semibold text-slate-700">Nozzle {nozzle.id}</span>
                    <select 
                      className={`input-field w-auto min-w-[140px] py-1.5 px-3 border-2 ${
                        nozzle.type === 'Petrol' ? 'border-orange-200 text-orange-700 bg-orange-50' :
                        nozzle.type === 'Diesel' ? 'border-blue-200 text-blue-700 bg-blue-50' :
                        'border-emerald-200 text-emerald-700 bg-emerald-50'
                      }`}
                      value={nozzle.type}
                      onChange={(e) => handleTypeChange(pump.pumpId, nozzle.id, e.target.value)}
                    >
                      {FUEL_TYPES.map(type => (
                        <option key={type} value={type}>{type}</option>
                      ))}
                    </select>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PumpConfig;
